'use client';

import { initLocale } from '.';
initLocale();
export default function LocaleClient() {
  return <></>;
}